import httpClient from '../http'

export default {
  fileUpload(file) {
    const formData = new FormData()
    formData.append('file', file)
    formData.append('filetype', 'csv')
    return httpClient.post(`/api/restock-order`, formData )
  }
}